<template>
  <div class="block-default" :class="[classNames]" :style="styles" @click="onClick">
    <slot></slot>
  </div>
</template>

<script>
export const Direction = Object.freeze({
  row: 'row',
  column: 'column'
})

export const Sort = Object.freeze({
  left_top: 'left_left',
  left_center: 'left_center',
  left_bottom: 'left_bottom',
  center_top: 'center_top',
  center_center: 'center_center',
  center_bottom: 'center_bottom',
  right_top: 'right_top',
  right_center: 'right_center',
  right_bottom: 'right_bottom',
  space_between: 'space_between'
})

export default {
  name: 'VBlock',
  props: {
    direction: {
      type: String,
      default: Direction.row
    },
    sort: {
      type: String,
      default: Sort.center_center
    },
    margin: {
      type: Array,
      default: () => []
    },
    padding: {
      type: Array,
      default: () => []
    },
    onClick: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    calcPosition(array) {
      return array.reduce((iter, curr, idx) => {
        if (idx === 0) {
          iter = `${curr}px`
        } else {
          iter += ` ${curr}px`
        }

        return iter
      }, '')
    }
  },
  computed: {
    classNames() {
      return [`${this.direction}`, `${this.direction === Direction.column ? 'r_' : ''}${this.sort}`]
    },
    styles() {
      const obj = {}
      this.margin.length > 0 && (obj['margin'] = this.calcPosition(this.margin))
      this.padding.length > 0 && (obj['padding'] = this.calcPosition(this.padding))

      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.block-default {
  width: 100%;
  display: flex;
  box-sizing: border-box;
}

.row {
  flex-direction: row;
}

.column {
  flex-direction: column;
}

.left_top {
  justify-content: flex-start;
  align-items: flex-start;
}

.left_center {
  justify-content: flex-start;
  align-items: center;
}

.left_bottom {
  justify-content: flex-start;
  align-items: flex-end;
}

.center_top {
  justify-content: center;
  align-items: flex-start;
}

.center_center {
  justify-content: center;
  align-items: center;
}

.center_bottom {
  justify-content: center;
  align-items: flex-end;
}

.right_top {
  justify-content: flex-end;
  align-items: flex-start;
}

.right_center {
  justify-content: flex-end;
  align-items: center;
}

.right_bottom {
  justify-content: flex-end;
  align-items: flex-end;
}

.r_left_top {
  justify-content: flex-start;
  align-items: flex-start;
}

.r_left_center {
  justify-content: center;
  align-items: flex-start;
}

.r_left_bottom {
  justify-content: flex-end;
  align-items: flex-start;
}

.r_center_top {
  justify-content: flex-start;
  align-items: center;
}

.r_center_center {
  justify-content: center;
  align-items: center;
}

.r_center_bottom {
  justify-content: flex-end;
  align-items: center;
}

.r_right_top {
  justify-content: flex-start;
  align-items: flex-end;
}

.r_right_center {
  justify-content: center;
  align-items: flex-end;
}

.r_right_bottom {
  justify-content: flex-end;
  align-items: flex-end;
}

.space_between,
.r_space_between {
  justify-content: space-between;
}
</style>
